/**
 * Session and Device Fingerprint utilities for rate limiting
 */

// Generate or retrieve a persistent session ID
export const getSessionId = () => {
  const SESSION_KEY = 'losspay_session_id';
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  
  if (!sessionId) {
    // Generate a new session ID using crypto.randomUUID if available, else fallback
    sessionId = typeof crypto !== 'undefined' && crypto.randomUUID 
      ? crypto.randomUUID()
      : `sess_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
    
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  
  return sessionId;
};

// Generate a simple device fingerprint based on browser characteristics
// Note: This is a basic implementation. For production, consider using a library like fingerprintjs
export const getDeviceFingerprint = () => {
  const FP_KEY = 'losspay_device_fp';
  let fingerprint = localStorage.getItem(FP_KEY);
  
  if (!fingerprint) {
    // Collect basic browser characteristics
    const components = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.platform || 'unknown'
    ];
    
    // Create a simple hash
    const str = components.join('|');
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    fingerprint = `fp_${Math.abs(hash).toString(36)}_${Date.now().toString(36)}`;
    localStorage.setItem(FP_KEY, fingerprint);
  }
  
  return fingerprint;
};

// Get headers for rate-limited endpoints
export const getRateLimitHeaders = () => ({
  'X-Session-ID': getSessionId(),
  'X-Device-Fingerprint': getDeviceFingerprint()
});
